module.exports = __webpack_public_path__ + "static/deloitteLandingHeader3-48e6e21cf69755be04a0e00c2037d52d.png";